// components/guards/RequireRegistered.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useUserDoc } from "../../hooks/useUserDoc";
import { atLeast } from "../../utils/onboarding";

export default function RequireRegistered({ children }) {
  const { loading, data } = useUserDoc();
  if (loading) return null;
  const isRegistered = data?.accountStatus === "registered";
  return isRegistered && atLeast(data?.onboarding?.step, "accountCreated") ? (
    children
  ) : (
    <Navigate to="/auth/create-account" replace />
  );
}
